export { default } from './notice'
export type { Props as NoticeProps } from './notice'
